import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import {darkModeState} from './state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'

const Header = ({ darkMode, setDarkMode, siteTitle }) => {
 //  let [darkMode, setDarkMode] = useRecoilState(darkModeState);

  return (<header className={"main-header" + (darkMode?" dark-mode":"")} 
  >
    <div
      className="container"
    >
      <div className="header-inner">
        <div className="site-logo">Mikayel Ghukasyan</div>
        <div className="site-menu">
          <ul className="main-nav">
            <li><button className={"button "+ (darkMode?"light-button":"dark-button")} onClick={() => setDarkMode(!darkMode)}><FontAwesomeIcon icon={ faLightbulb }/> <span>{darkMode?"Light Mode":"Dark Mode"}</span></button></li>
{/*             <li>About</li>
            <li>Skills</li>
            <li>Portfolio</li>
            <li>Why Me</li>
            <li>Contacts</li>
 */}
          </ul>
        </div>
      </div>

    </div>
  </header>
)}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
